module.exports = __webpack_public_path__ + "static/media/audi.28c54be1.png";